<template>
    <div class="widget webinar-widget">
        <header class="widget-header">
            <h3><i class="fal fa-chalkboard-teacher" />{{ config.title }}</h3>
        </header>
        <div class="widget-body">
            <div class="webinar-header">
                <div class="webinar-info">
                    <span
                        v-if="config.date"
                        class="date"
>
                        <i class="far fa-calendar" /> {{ config.date }}
                    </span>
                    <span
                        v-if="config.duration"
                        class="duration"
                    >
                        <i class="far fa-clock" /> {{ config.duration }}
                    </span>
                </div>
                <h3
                    v-if="config.subtitle"
                >
                    {{ config.subtitle }}
                </h3>
                <div class="hosted-by">
                    <div
                        v-if="config.avatar"
                        class="host-avatar round-image"
                    >
                        <img :src="config.avatar.src" :alt="config.avatar.alt">
                    </div>
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    <p>Hosted by <span v-html="config.hosts" /></p>
                </div>
            </div>
            <div
                v-if="config.description"
                class="webinar-description"
>
                <!-- eslint-disable vue/no-v-html -->
                <p v-html="config.description" />
            </div>
            <a
                v-if="config.cta.url"
                :href="config.cta.url"
                class="btn"
                target="_blank"
            >
                {{ config.cta.text }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        config: {
            type: Object,
            required: true,
        },
    },
};
</script>
